module.exports = __webpack_public_path__ + "static/media/3_custom_slides.3367c971.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/3_custom_slides.mp4
// module id = 311
// module chunks = 0